export interface NavigationItem {
  label: string;
  href: string;
  children?: NavigationItem[];
}

export const navigationItems: NavigationItem[] = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Services",
    href: "/services",   
  },
  {
    label: "Solutions",
    href: "/solutions",
    children: [
      { label: "Retail & E-commerce", href: "/solutions/retail" },
      { label: "Healthcare", href: "/solutions/healthcare" },
      { label: "FinTech", href: "/solutions/fintech" },
      { label: "Logistics", href: "/solutions/logistics" },
    ],
  },
  {
    label: "Case Studies",
    href: "/case-studies",
  },
  {
    label: "Blog",
    href: "/blog",
  },
  {
    label: "About",
    href: "/about",
  },
  {
    label: "Contact",
    href: "/contact",
  },
];